import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/images/placeholders/placeholder-video.png");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/admin/sidebar/AdminSidebar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/blocks/SchoolBlocks/Notification/NotificationContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/GoogleAnalyticsScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/LanguageTool/LanguageTool.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavFooter"] */ "/app/packages/components/components/header/navigation/MobileNav/MobileNavFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderShortcuts"] */ "/app/packages/components/components/header/shortcuts/HeaderShortcuts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebAppInstallPrompt"] */ "/app/packages/components/components/header/WebAppInstallPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/misc/AdminMenuClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationContainer"] */ "/app/packages/components/components/notifications/NotificationContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/SchoolFeedWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/utilities/ClickableLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DragAndDropProvider"] */ "/app/packages/components/components/utilities/DragAndDropProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/errors/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerManager"] */ "/app/packages/components/components/utilities/ServiceWorkerManager.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/UnreadNotificationsConsumer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/AccordionItemPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/NewsItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/WelcomePage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/stores/ClientTransitionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreContext"] */ "/app/packages/components/stores/StoreContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/styles/_variables.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/styles/ContentItemPage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/utils/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipToSchoolFeedLink"] */ "/app/packages/schoolblocks/app/[lang]/[[...all]]/SkipToSchoolFeedLink.jsx");
